import {
  UPDATE_DRIVER_REQUEST,
  UPDATE_DRIVER_ERROR,
  UPDATE_DRIVER_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/updateEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default (entity, entityTableData) => (state = initialState, action) => {

  context.init(context);

  context.UPDATE_ENTITY_REQUEST = UPDATE_DRIVER_REQUEST;
  context.UPDATE_ENTITY_ERROR = UPDATE_DRIVER_ERROR;
  context.UPDATE_ENTITY_SUCCESS = UPDATE_DRIVER_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "driver";
  context.entityLocation = RESOURCES.Drivers;

  return context.execute(context)(entity, entityTableData)(state, action);
};